import { motion } from "framer-motion";

export default function SanMarinoMarketBanner() {
  return (
    <section data-testid="san-marino-market-banner" className="py-16 sm:py-24 lg:py-32 bg-[#050505]">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="border border-[#E97A1F]/30 bg-[#0d0d0d] overflow-hidden"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-8 sm:p-12 flex flex-col justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/65hp5wdj_Contemporary%20Emblem%20Logo%20for%20SAN%20MARINO%20MARKET.png"
                alt="San Marino Market"
                className="w-48 h-auto mb-6"
              />
              <h3 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">
                Siamo i creatori di<br />
                <span style={{ color: "#E97A1F" }}>San Marino Market</span>
              </h3>
              <p className="text-[#A3A3A3] font-body text-base mt-4 leading-relaxed">
                Il Mercato del Titano. La piattaforma per comprare, vendere e barattare nella Repubblica di San Marino. Annunci, aste live e pagamenti sicuri.
              </p>
              <div className="mt-8">
                <a
                  href="mailto:info@sanmarinomarket.com"
                  data-testid="san-marino-market-email-btn"
                  className="inline-flex items-center gap-3 bg-[#E97A1F] text-white font-bold uppercase tracking-widest px-6 py-4 text-xs hover:bg-white hover:text-[#E97A1F] transition-colors duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                  PROBLEMI CON ANNUNCI? SCRIVICI
                </a>
                <p className="text-[#A3A3A3] text-xs font-mono mt-3">
                  info@sanmarinomarket.com
                </p>
              </div>
            </div>
            <div className="relative overflow-hidden min-h-[300px] lg:min-h-0">
              <img
                src="https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/oel4alv1_ChatGPT%20Image%206%20mag%202026%2C%2012_56_21.png"
                alt="San Marino Market Screenshot"
                className="w-full h-full object-cover object-left-top"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
